@if (hasCards()) {
<div class="reports-overview-page px-2 pb-2">
  <div class="row g-3">
    @for (card of cards(); track card.key) {
    <div class="col-12 col-md-6 col-xl-4">
      <a class="report-overview-card d-flex flex-column" [attr.data-accent]="card.accent" [routerLink]="card.routerLink">
        <div class="card-header d-flex align-items-center">
          <div class="card-icon d-flex align-items-center justify-content-center flex-shrink-0" [attr.data-accent]="card.accent">
            <mat-icon>{{ card.icon }}</mat-icon>
          </div>
          <span class="card-title">{{ card.titleKey | translate }}</span>
          <mat-icon class="card-arrow ms-auto">chevron_right</mat-icon>
        </div>
        <p class="card-description">{{ card.descriptionKey | translate }}</p>
        <div class="card-metric d-flex flex-column mt-auto">
          <span class="metric-label">{{ card.metricLabelKey | translate }}</span>
          @if (card.isLoading()) {
          <mat-progress-spinner mode="indeterminate" diameter="20" />
          } @else {
          <span class="metric-value" [class.metric-error]="card.hasError()">{{ card.metricValue() }}</span>
          }
        </div>
      </a>
    </div>
    }
  </div>
</div>
} @else {
<div class="reports-overview-empty d-flex flex-column align-items-center justify-content-center h-100">
  <mat-icon>bar_chart</mat-icon>
  <span>{{ 'app.reports.overview.empty_state' | translate }}</span>
</div>
}
